import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface GetErgonomicWorkAnalysisImagesListParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useGetErgonomicWorkAnalysisImagesList = (params: GetErgonomicWorkAnalysisImagesListParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ERGONOMIC_WORK_ANALYSIS_IMAGES, params],
		queryFn: () => Service.getImages(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.id,
		retry: 0,
		onError: () => {
			message.error(I18n.get('Error getting images'));
		}
	});
};
